import { Card, CardContent, Typography, TextField, Stack } from '@mui/material';

interface GroupNameCardProps {
  name: string;
  onChange: (name: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  dataTestId?: string;
}

export function GroupNameCard({
  name,
  onChange,
  disabled = false,
  autoFocus = false,
  dataTestId = 'group-name-input',
}: GroupNameCardProps) {
  return (
    <Card variant="outlined" data-testid="group-name-card">
      <CardContent>
        <Stack spacing={2}>
          {/* Card Title */}
          <Typography variant="h6" component="h3">
            Group Name
          </Typography>

          {/* Explanatory Text */}
          <Typography variant="body2" color="text.secondary">
            Enter a descriptive name for this labour group to help organise your
            labour items.
          </Typography>

          {/* Text Input */}
          <TextField
            fullWidth
            value={name}
            onChange={e => onChange(e.target.value)}
            placeholder="Enter group name"
            disabled={disabled}
            autoFocus={autoFocus}
            data-testid={dataTestId}
            size="small"
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
